<div class="ui segment flat-preview-item"
     [class.sold-out]="flat.soldOut"
     [ngClass]="{'no-price': flat.price === 0}"
     (click)="openFlatPage(flat)">
  <a class="ui ribbon label flat-price-label" *ngIf="!flat.soldOut" [ngClass]="{'transparent': flat.price === 0}">
    {{removeHuf(flat.price | currency : 'HUF' : 'symbol' : '1.0-0')}} Forint
  </a>
  <app-sold-out *ngIf="flat.soldOut"></app-sold-out>
  <div class="ui items"  [ngClass]="{'sold-out': flat.soldOut}">
    <div class="item">
      <div class="image">
<!--        <img [src]="'/assets/images/projects/' + flat.project.toLowerCase() + '/flats/small/' + flat.id + '_P.jpg'">-->
        <img [src]="flat.salesImageUrl">
      </div>

      <div class="content">
        <h2 class="flat-name">
          {{flat.name}}
          <span *ngIf="flat.concat"> (összevonás) </span>
        </h2>
        <div class="ui label label">
          {{flat.size}} m² <ng-container *ngIf="getTerraceSize(flat)">+ {{getTerraceSize(flat)}} m² terasz</ng-container>
        </div>
        <div class="ui label label">
          <span *ngIf="flat.level === 0">Földszint</span>
          <span *ngIf="flat.level !== 0">{{flat.level}}. emelet</span>
        </div>
        <div class="ui label label" *ngIf="!flat.isOffice">
          Szobák száma: {{flat.numberOfRooms}}
        </div>
        <div class="ui label label" *ngIf="flat.garden">
          Kertkapcsolat, udvar: {{flat.garden}} m²
        </div>
        <div class="ui label reserved-label" *ngIf="flat.reserved">
          Foglalt
        </div>


      </div>
    </div>
  </div>
</div>
